/* eslint-disable react/no-danger */
// @flow
import React from 'react';
import cx from 'classnames';
import styles from './styles.scss';

export const ButtonSupplimentaryTextNotice = 'ButtonSupplimentaryTextNotice';
export const ButtonSupplimentaryTextLink = 'ButtonSupplimentaryTextLink';
export type ButtonSupplimentaryTextType = 'ButtonSupplimentaryTextNotice' | 'ButtonSupplimentaryTextLink';

type Props = {
  type: ButtonSupplimentaryTextType,
  noticeText: ?string,
  linkText: ?string,
  linkUrl: ?string,
  theme: string,
};

const ButtonSupplimentaryText = ({ type, noticeText, linkText, linkUrl, theme }: Props) => {
  const isLink = type === ButtonSupplimentaryTextLink;
  let content;
  if (isLink) {
    content = <a href={linkUrl}>{linkText}</a>;
  } else {
    content = noticeText;
  }
  const linkClassName = isLink ? styles['is-link'] : null;
  const classNames = cx(linkClassName, styles[theme]);

  return (
    <p id={styles.container} className={classNames}>
      {content}
    </p>
  );
};

// ButtonSupplimentaryText.defaultProps = {
//   redirectNoticeText: '',
//   linkText: ''
// };

export default ButtonSupplimentaryText;



// WEBPACK FOOTER //
// ./src/components/ButtonSupplimentaryText/ButtonSupplimentaryText.js